import {Chip} from "@mui/material";
import * as React from 'react'

interface RangeChipProps {
  label: any;
  selected?: any;
  isSelected: boolean;
  onClick: any;
}

export function RangeChip(props: RangeChipProps) {

  function rangeVariant() {
    return props.isSelected ? 'filled' : 'outlined'
  }

  return <Chip label={props.label} variant={rangeVariant()}
               sx={{fontWeight: 700, background: 'rgb(255, 26, 61)', color: "white", minWidth: 160}}
               onClick={props.onClick}/>
}